export default __webpack_public_path__ + "static/media/ga-001.3b5d7441.jpg";